<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { getContacts } from '@shared/config'
import { trackEvent } from '@shared/lib/amplitude'

import { useContactLaunchers } from './contact-launchers.hook'

defineOptions({
  name: 'LinkWhatsApp',
})

const text = 'WhatsApp'
const contacts = getContacts()

const {
  openWhatsApp,
} = useContactLaunchers()

const setSubmit = (): void => {
  const options = {
    phone: contacts.whatsUpPhone,
    text: 'Support request',
  }
  trackEvent('Link_click', { feature: 'support', name: 'whatsapp', text, channel: 'whatsapp' })
  openWhatsApp(options)
}
</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="whatsapp"
        size="md"
      />
    </template>
  </DropdownItem>
</template>
